// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__3hDN9","modalOverlay":"styles_modalOverlay__1DGwn","title":"styles_title__3pMQd"};